module.exports = __webpack_public_path__ + "static/media/YM76_4.0ac896e6.jpg";